export default "__VITE_ASSET__152b3ca6__"